export enum actionTypes {
  IDIOMAS_FETCH = 'IDIOMAS_FETCH',
  IDIOMAS_SUCCESS = 'IDIOMAS_SUCCESS',
  IDIOMAS_ERROR = 'IDIOMAS_ERROR',
  IDIOMAS_RESET = 'IDIOMAS_RESET',
}

export enum IdiomasStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Idioma {
  id: number
  nombre: string
}

export interface IdiomasState {
  status: IdiomasStatus
  idiomas: Array<Idioma>
}

export interface IdiomasFetch {
  type: typeof actionTypes.IDIOMAS_FETCH
  payload: null
}

export interface IdiomasSuccess {
  type: typeof actionTypes.IDIOMAS_SUCCESS
  payload: { idiomas }
}

export interface IdiomasError {
  type: typeof actionTypes.IDIOMAS_ERROR
  payload: null
}

export interface IdiomasReset {
  type: typeof actionTypes.IDIOMAS_RESET
  payload: null
}

export type IdiomasActions =
  | IdiomasFetch
  | IdiomasSuccess
  | IdiomasError
  | IdiomasReset

export const initialState: IdiomasState = {
  status: IdiomasStatus.Idle,
  idiomas: [],
}
